"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var financeAndInsuranceSummaryStyles = makeStyles_1.default(function (theme) { return ({
    summaryLabel: {
        fontFamily: theme.typography.fontFamily,
    },
}); }, { name: 'Checkout4_FinanceAndInsuranceSummary' });
exports.default = financeAndInsuranceSummaryStyles;
